export default __webpack_public_path__ + "static/media/din2p-3.610b51d6.png";